export function generateEndedOverlay(player) {
    const localize = player.localize?.bind(player);
    const template =  `<div>
        <a target="_blank">
            <img class="vjs-presentation-ended-image" alt="${localize('Presentation Ended')}" width="520" height="70">
            <div aria-hidden="true" class="vjs-presentation-ended-text">${localize('Presentation Ended')}</div>
        </a>
        <div>
            <button type="button" class="mediasite-player__presentation-ended-replay-button">
                <span aria-hidden="true" class="vjs-icon-replay"></span>
                ${localize('Replay')}
            </button>
        </div>
    </div>`;

    const element = document.createElement('div');
    element.innerHTML = template;
    return element.firstElementChild;
}